import React from "react";
import { usePreview } from "react-dnd-preview";

import { dndItemTypes } from "./DndConfig";
import { LetterCardFilled } from "../games/blending/LetterCard";
import { WordCardFilled } from "../games/high-frequency-word/WordCard";
import { BasketItemFilled } from "../games/phoneme/BasketItem";

interface Props {
  scale: number;
  itemLeft: number;
  itemRight: number;
}

const DndPreview = (props: Props) => {
  const { scale, itemLeft, itemRight } = props;
  const { display, itemType, item, style } = usePreview();
  if (!display) return null;

  let translateArr: string[] = style.transform.split(/\(|\)|, /).slice(1, 3);
  translateArr = translateArr.map((str) => {
    const coordinate = Number(str.substring(0, str.length - 2));
    return `${coordinate / scale}px`;
  });

  const transform = `translate(${translateArr.join(", ")})`;

  const customStyle: React.CSSProperties = {
    position: "absolute",
    zIndex: 10, // must be smaller than drop item
    top: 0,
    left: `${itemLeft + itemRight}px`,
    transform: transform,
    WebkitTransform: transform,
  };

  switch (itemType) {
    case dndItemTypes.BLENDING_LETTER_CARD:
    case dndItemTypes.BLENDING_ONBOARD_LETTER_CARD:
      return (
        <LetterCardFilled
          dragRef={null}
          canDrag={false}
          isDragging={true}
          alphabet={item.alphabet}
          style={customStyle}
        />
      );
    case dndItemTypes.HIGH_FREQUENCY_WORD_CARD:
      return (
        <WordCardFilled
          dragRef={null}
          canDrag={false}
          word={item.word}
          style={customStyle}
        />
      );
    case dndItemTypes.PHONEME_BASKET_ITEM:
      return (
        <BasketItemFilled
          dragRef={null}
          word={item.word}
          outIndex={item.outIndex}
          isDragging={true}
          style={customStyle}
        />
      );
  }
};

export default DndPreview;
